/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
    m11EligibilityCriteriaFoiChanged, m11EligibilityCriteriaResourceChanged,
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged, m11ReportSection05FoiChanged,
    m11ReportSection05ResourceChanged, selectM11EligibilityCriteriaFoi,
    selectM11EligibilityCriteriaResource, selectM11ReportContainerFoi,
    selectM11ReportContainerResource, selectM11ReportSection05Foi,
    selectM11ReportSection05Resource, selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import getFhirJson from "../../functions/getFhirJsonAPI";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";
import CodeEntry from "../../datatypeComponents/CodeEntry";

const saveTrialPopulationChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section05State, setAlertModalState, setStartingSection05State) => {

    let changesStates = {
        section05State: section05State
    };
    let response = await saveM11Changes(apiToken, 7, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection05Resource) {
            dispatch(m11ReportSection05ResourceChanged(response.m11ReportSection05Resource));
        }
        setStartingSection05State(JSON.parse(JSON.stringify(section05State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const loadGroupResource = async (groupFoi, dispatch, apiToken) => {
    let groupJson = await getFhirJson(groupFoi, null, apiToken);
    if (groupJson) {
        dispatch(m11EligibilityCriteriaResourceChanged(groupJson));
    }
};

const M11Step007TrialPopulation = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11User = useSelector(selectCurrentUserM11Use);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection05Foi = useSelector(selectM11ReportSection05Foi);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);
    const m11ReportSection05Resource = useSelector(selectM11ReportSection05Resource);
    const m11EligibilityCriteriaFoi = useSelector(selectM11EligibilityCriteriaFoi);
    const m11EligibilityCriteriaResource = useSelector(selectM11EligibilityCriteriaResource);

    const [section05State, setSection05State] = useState({
        "section51Status": "empty", "section51Xhtml": "",
        "section52Status": "empty", "section52Xhtml": "",
        "lumpOrSplit": "",
        "section55Status": "empty", "section55Xhtml": "",
        "section551Status": "empty", "section551Xhtml": "",
        "section552Status": "empty", "section552Xhtml": "",
        "section553Status": "empty", "section553Xhtml": "",
        "section554Status": "empty", "section554Xhtml": "",
        "section53Status": "empty", "section53Xhtml": "",
        "section541Status": "empty", "section541Xhtml": "",
        "section542Status": "empty", "section542Xhtml": "",
        "section56Status": "empty", "section56Xhtml": ""
    });
    const [startingSection05State, setStartingSection05State] = useState({
        "section51Status": "empty", "section51Xhtml": "",
        "section52Status": "empty", "section52Xhtml": "",
        "lumpOrSplit": "",
        "section55Status": "empty", "section55Xhtml": "",
        "section551Status": "empty", "section551Xhtml": "",
        "section552Status": "empty", "section552Xhtml": "",
        "section553Status": "empty", "section553Xhtml": "",
        "section554Status": "empty", "section554Xhtml": "",
        "section53Status": "empty", "section53Xhtml": "",
        "section541Status": "empty", "section541Xhtml": "",
        "section542Status": "empty", "section542Xhtml": "",
        "section56Status": "empty", "section56Xhtml": ""
    });
    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
    const [eligibilityLoadingNeeded, setEligibilityLoadingNeeded] = useState(false);

    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section05State, startingSection05State)),
        async saveAllChanges() {
            await saveTrialPopulationChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section05State, setAlertModalState, setStartingSection05State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ResearchStudyResource.recruitment?.eligibility &&
                getIdFromReference(m11ResearchStudyResource.recruitment.eligibility)) {
                let groupFoi = getIdFromReference(m11ResearchStudyResource.recruitment.eligibility);
                if (groupFoi && !isNaN(groupFoi) && groupFoi !== m11EligibilityCriteriaFoi) {
                    dispatch(m11EligibilityCriteriaFoiChanged(groupFoi));
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
                setEligibilityLoadingNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (m11EligibilityCriteriaFoi && !isNaN(m11EligibilityCriteriaFoi)) {
            loadGroupResource(m11EligibilityCriteriaFoi, dispatch, apiToken);
        }
    }, [m11EligibilityCriteriaFoi]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            let startingData = {
                "section51Status": "empty", "section51Xhtml": "",
                "section52Status": "empty", "section52Xhtml": "",
                "lumpOrSplit": "",
                "section55Status": "empty", "section55Xhtml": "",
                "section551Status": "empty", "section551Xhtml": "",
                "section552Status": "empty", "section552Xhtml": "",
                "section553Status": "empty", "section553Xhtml": "",
                "section554Status": "empty", "section554Xhtml": "",
                "section53Status": "empty", "section53Xhtml": "",
                "section541Status": "empty", "section541Xhtml": "",
                "section542Status": "empty", "section542Xhtml": "",
                "section56Status": "empty", "section56Xhtml": "",
                "loaded": true
            };
            if (m11ResearchStudyResource.recruitment?.description) {
                startingData.section51Status = "generated";
                startingData.section51Xhtml = "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" +
                    m11ResearchStudyResource.recruitment.description +
                    "</p><p>Prospective approval of protocol deviations to recruitment and enrollment criteria, also known as protocol waivers or exemptions, is not permitted.</p></div>";
            }
            setSection05State(startingData);
            setStartingSection05State({
                "section51Status": "empty", "section51Xhtml": "",
                "section52Status": "empty", "section52Xhtml": "",
                "section551Status": "empty", "section551Xhtml": "",
                "section552Status": "empty", "section552Xhtml": "",
                "section553Status": "empty", "section553Xhtml": "",
                "section554Status": "empty", "section554Xhtml": "",
                "section53Status": "empty", "section53Xhtml": "",
                "section541Status": "empty", "section541Xhtml": "",
                "section542Status": "empty", "section542Xhtml": "",
                "section56Status": "empty", "section56Xhtml": "",
                "loaded": true
            });
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (eligibilityLoadingNeeded === true && m11EligibilityCriteriaResource &&
            Object.keys(m11EligibilityCriteriaResource).length > 0 &&
            section05State.loaded === true) {
            if (m11EligibilityCriteriaResource.characteristic?.length > 0) {
                let inclusionList = [];
                let exclusionList = [];
                for (const characteristic of m11EligibilityCriteriaResource.characteristic) {
                    if (characteristic.description && characteristic.exclude === false) {
                        inclusionList.push(characteristic.description);
                    }
                    if (characteristic.description && characteristic.exclude === true) {
                        exclusionList.push(characteristic.description);
                    }
                }
                let inclusionCriteria = "<div xmlns=\"http://www.w3.org/1999/xhtml\">";
                let exclusionCriteria = "<div xmlns=\"http://www.w3.org/1999/xhtml\">";
                if (inclusionList.length > 0) {
                    inclusionCriteria += "<p>To be eligible to participate in this trial, an individual must meet all the following criteria:</p>";
                    inclusionCriteria += inclusionList.map((line, index) => {
                        return "<p>" + String(index + 1) + ". " + line + "</p>";
                    }).join("");
                    inclusionCriteria += "</div>";
                } else {
                    inclusionCriteria += "There are no inclusion criteria.</div>";
                }
                exclusionCriteria += "<p>An individual who meets any of the following criteria will be excluded from participation in this trial: </p>";
                if (exclusionList.length > 0) {
                    exclusionCriteria += exclusionList.map((line, index) => {
                        return "<p>" + String(index + 1) + ". " + line + "</p>";
                    }).join("");
                    exclusionCriteria += "</div>";
                } else {
                    exclusionCriteria += "<p>There are no exclusion criteria.</p></div>";
                }
                setSection05State(prevState => {
                    return {
                        ...prevState,
                        section52Status: "generated",
                        section52Xhtml: inclusionCriteria,
                        section53Status: "generated",
                        section53Xhtml: exclusionCriteria,
                        eligibilityLoaded: true
                    };
                });
                setStartingSection05State(prevState => {
                    return {
                        ...prevState,
                        section52Status: "generated",
                        section52Xhtml: inclusionCriteria,
                        section53Status: "generated",
                        section53Xhtml: exclusionCriteria,
                        eligibilityLoaded: true
                    };
                });
            }
        }
    }, [eligibilityLoadingNeeded, m11EligibilityCriteriaResource, section05State.loaded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[5]?.entry?.length) {
                let m11ReportSection005Foi = getIdFromReference(m11ReportContainerResource.section[5].entry[0]);
                if (m11ReportSection005Foi && !isNaN(m11ReportSection005Foi) && m11ReportSection005Foi !== m11ReportSection05Foi) {
                    dispatch(m11ReportSection05FoiChanged(m11ReportSection005Foi));
                } else {
                    setInitialCalculationNeeded(true);
                    setEligibilityLoadingNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
                setEligibilityLoadingNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection05Foi && !isNaN(m11ReportSection05Foi)) {
            loadResource(m11ReportSection05Foi, "M11ReportSection05", apiToken, dispatch);
        }
    }, [m11ReportSection05Foi]);

    useEffect(() => {
        if (m11ReportSection05Resource && Object.keys(m11ReportSection05Resource).length > 0) {
            let startingData = {
                "section51Status": "empty", "section51Xhtml": "",
                "section52Status": "empty", "section52Xhtml": "",
                "lumpOrSplit": "",
                "section55Status": "empty", "section55Xhtml": "",
                "section551Status": "empty", "section551Xhtml": "",
                "section552Status": "empty", "section552Xhtml": "",
                "section553Status": "empty", "section553Xhtml": "",
                "section554Status": "empty", "section554Xhtml": "",
                "section53Status": "empty", "section53Xhtml": "",
                "section541Status": "empty", "section541Xhtml": "",
                "section542Status": "empty", "section542Xhtml": "",
                "section56Status": "empty", "section56Xhtml": "",
                "loaded": true
            };
            if (m11ReportSection05Resource.section?.[0]?.section?.length > 0) {
                if (m11ReportSection05Resource.section[0].section[0]?.text?.div &&
                    m11ReportSection05Resource.section[0].section[0].text.status !== "empty") {
                    startingData.section51Status = m11ReportSection05Resource.section[0].section[0].text.status;
                    startingData.section51Xhtml = m11ReportSection05Resource.section[0].section[0].text.div;
                }
                if (m11ReportSection05Resource.section[0].section[1]?.text?.div &&
                    m11ReportSection05Resource.section[0].section[1].text.status !== "empty") {
                    startingData.section52Status = m11ReportSection05Resource.section[0].section[1].text.status;
                    startingData.section52Xhtml = m11ReportSection05Resource.section[0].section[1].text.div;
                    startingData.eligibilityLoaded = true;
                } else {
                    setEligibilityLoadingNeeded(true);
                }
                if (m11ReportSection05Resource.section[0].section[2]?.text?.div &&
                    m11ReportSection05Resource.section[0].section[2].text.status !== "empty") {
                    startingData.section53Status = m11ReportSection05Resource.section[0].section[2].text.status;
                    startingData.section53Xhtml = m11ReportSection05Resource.section[0].section[2].text.div;
                } else {
                    setEligibilityLoadingNeeded(true);
                }
                if (m11ReportSection05Resource.section[0].section[3]?.section?.[0]?.text?.div &&
                    m11ReportSection05Resource.section[0].section[3].section[0].text.status !== "empty") {
                    startingData.section541Status = m11ReportSection05Resource.section[0].section[3].section[0].text.status;
                    startingData.section541Xhtml = m11ReportSection05Resource.section[0].section[3].section[0].text.div;
                }
                if (m11ReportSection05Resource.section[0].section[3]?.section?.[1]?.text?.div &&
                    m11ReportSection05Resource.section[0].section[3].section[1].text.status !== "empty") {
                    startingData.section542Status = m11ReportSection05Resource.section[0].section[3].section[1].text.status;
                    startingData.section542Xhtml = m11ReportSection05Resource.section[0].section[3].section[1].text.div;
                }
                if (m11ReportSection05Resource.section[0].section[4]?.text?.div &&
                    m11ReportSection05Resource.section[0].section[4].text.status !== "empty") {
                    startingData.section55Status = m11ReportSection05Resource.section[0].section[4].text.status;
                    startingData.section55Xhtml = m11ReportSection05Resource.section[0].section[4].text.div;
                    startingData.lumpOrSplit = "Lump";
                }
                if (m11ReportSection05Resource.section[0].section[4]?.section?.length > 0) {
                    if (m11ReportSection05Resource.section[0].section[4].section[0]?.text?.div &&
                        m11ReportSection05Resource.section[0].section[4].section[0].text.status !== "empty") {
                        startingData.section551Status = m11ReportSection05Resource.section[0].section[4].section[0].text.status;
                        startingData.section551Xhtml = m11ReportSection05Resource.section[0].section[4].section[0].text.div;
                        startingData.lumpOrSplit = "Split";
                    }
                    if (m11ReportSection05Resource.section[0].section[4].section?.[1]?.text?.div &&
                        m11ReportSection05Resource.section[0].section[4].section[1].text.status !== "empty") {
                        startingData.section552Status = m11ReportSection05Resource.section[0].section[4].section[1].text.status;
                        startingData.section552Xhtml = m11ReportSection05Resource.section[0].section[4].section[1].text.div;
                    }
                    if (m11ReportSection05Resource.section[0].section[4].section?.[2]?.text?.div &&
                        m11ReportSection05Resource.section[0].section[4].section[2].text.status !== "empty") {
                        startingData.section553Status = m11ReportSection05Resource.section[0].section[4].section[2].text.status;
                        startingData.section553Xhtml = m11ReportSection05Resource.section[0].section[4].section[2].text.div;
                    }
                    if (m11ReportSection05Resource.section[0].section[4].section[3]?.text?.div &&
                        m11ReportSection05Resource.section[0].section[4].section[3].text.status !== "empty") {
                        startingData.section554Status = m11ReportSection05Resource.section[0].section[4].section[3].text.status;
                        startingData.section554Xhtml = m11ReportSection05Resource.section[0].section[4].section[3].text.div;
                    }
                }
                if (m11ReportSection05Resource.section[0].section[5]?.text?.div &&
                    m11ReportSection05Resource.section[0].section[5].text.status !== "empty") {
                    startingData.section56Status = m11ReportSection05Resource.section[0].section[5].text.status;
                    startingData.section56Xhtml = m11ReportSection05Resource.section[0].section[5].text.div;
                }
                setSection05State(startingData);
                setStartingSection05State(startingData);
            } else {
                setInitialCalculationNeeded(true);
                setEligibilityLoadingNeeded(true);
            }
        }
    }, [m11ReportSection05Resource]);

    return <div>
        <h3>Complete Section 5 Trial Population</h3>
        {!(m11ReportSection05Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {section05State.loaded && <>
            <h4 style={{ marginBottom: "0px" }}>Revise 5.1 Description of Trial Population and Rationale summary as needed.</h4>
            <TextDivEntry elementName="section51Xhtml"
                startingValue={section05State.section51Xhtml}
                setResourceState={setSection05State} />
            <h4 style={{ marginBottom: "0px" }}>Revise 5.2 Inclusion Criteria summary as needed.</h4>
            {section05State.eligibilityLoaded &&
                <TextDivEntry elementName="section52Xhtml"
                    startingValue={section05State.section52Xhtml}
                    setResourceState={setSection05State} />}
            <h4 style={{ marginBottom: "0px" }}>Revise 5.3 Exclusion Criteria summary as needed.</h4>
            {section05State.eligibilityLoaded &&
                <TextDivEntry elementName="section53Xhtml"
                    startingValue={section05State.section53Xhtml}
                    setResourceState={setSection05State} />}
            <h4 style={{ marginBottom: "0px" }}>Enter or revise 5.4.1 Definitions Related to Childbearing Potential summary as needed.</h4>
            <TextDivEntry elementName="section541Xhtml"
                startingValue={section05State.section541Xhtml}
                setResourceState={setSection05State} />
            <h4 style={{ marginBottom: "0px" }}>Enter or revise 5.4.2 Contraception Requirements summary as needed.</h4>
            <TextDivEntry elementName="section542Xhtml"
                startingValue={section05State.section542Xhtml}
                setResourceState={setSection05State} />
            <h4 style={{ marginBottom: "0px" }}>Enter data for Section 5.5 Lifestyle Restrictions.</h4>
            {section05State.lumpOrSplit === "Lump" ?
                <TextDivEntry elementName="section55Xhtml"
                    startingValue={section05State.section55Xhtml}
                    setResourceState={setSection05State} />
                :
                section05State.lumpOrSplit === "Split" ?
                    <>
                        <h5 style={{ marginBottom: "0px" }}>Revise the Section 5.5.1 Meals and Dietary Restrictions as needed.</h5>
                        <TextDivEntry elementName="section551Xhtml"
                            startingValue={section05State.section551Xhtml}
                            setResourceState={setSection05State} />
                        <h5 style={{ marginBottom: "0px" }}>Revise the Section 5.5.2 Caffeine, Alcohol, Tobacco, and Other Restrictions as needed.</h5>
                        <TextDivEntry elementName="section552Xhtml"
                            startingValue={section05State.section552Xhtml}
                            setResourceState={setSection05State} />
                        <h5 style={{ marginBottom: "0px" }}>Revise the Section 5.5.3 Physical Activity Restrictions as needed.</h5>
                        <TextDivEntry elementName="section553Xhtml"
                            startingValue={section05State.section553Xhtml}
                            setResourceState={setSection05State} />
                        <h5 style={{ marginBottom: "0px" }}>Revise the Section 5.5.4 Other Activity Restrictions as needed.</h5>
                        <TextDivEntry elementName="section554Xhtml"
                            startingValue={section05State.section554Xhtml}
                            setResourceState={setSection05State} />
                    </>
                    :
                    <>
                        <h5 style={{ marginBottom: "0px" }}>DECIDE whether to summarize as one section (Lump) or multiple subsections (Split).</h5>
                        <CodeEntry elementName='lumpOrSplit' fieldLabel='Lump or Split'
                            startingValue={section05State.lumpOrSplit} setResourceState={setSection05State}
                            allowedValues={["Lump", "Split"]} />
                    </>
            }
            <h4 style={{ marginBottom: "0px" }}>Enter data for Section 5.6 Screen Failure and Rescreening.</h4>
            <TextDivEntry elementName="section56Xhtml"
                startingValue={section05State.section56Xhtml}
                setResourceState={setSection05State} />
            {m11User === "sample" && <div>
                <p>You are using the M11 Report Authoring Tool (Test Drive Version). Go to Step 40 for the next available step.</p>
            </div>}
        </>}
    </div >
});

const M11Step007TrialPopulationHelperText = <div>
    <h3>Complete Section 5 Trial Population</h3>
    <div style={{ textAlign: "left" }}>
        <p>Revise 5.1 Description of Trial Population and Rationale summary as needed.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe the population selected (e.g., healthy participants, adult participants, paediatric participants, pregnant participants, or breastfeeding participants) and how the enrollment criteria reflect the populations that are likely to use the drug if approved. Specify the population age range (e.g., ≤3 months, ≥18 to ≤80 years old) including the time point at which qualification for age criteria is determined (e.g., at time of screening vs randomisation for paediatric trials). Specify any key diagnostic criteria for the population (e.g., “acute lung injury”, or a specific biomarker profile). If applicable, describe similar conditions or diseases and their differential diagnosis. Provide a rationale for the trial population ensuring that the population selected is well defined and clinically recognisable. Describe how the selected population can meet the trial objectives and how the enrollment criteria reflect the population of interest. If the population targeted by a clinical question is based on a subset of the entire trial population, e.g., defined by a particular characteristic measured at baseline (e.g., a specific biomarker), this subset should be justified in this section. Justify whether the trial intervention is to be evaluated in paediatric participants, in adults unable to consent for themselves, other vulnerable participant populations, or those that may respond to the trial intervention differently (e.g., elderly, hepatic or renally impaired, or immunocompromised participants).</p>
        </div>
        <p>Revise 5.2 Inclusion Criteria summary as needed.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Inclusion criteria are characteristics that define the trial population, i.e., those criteria that every potential participant must satisfy to qualify for trial enrollment.</p>
        </div>
        <p>Revise 5.3 Exclusion Criteria summary as needed.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Exclusion criteria are characteristics that make an individual ineligible for participation.</p>
        </div>
        <p>Enter or revise 5.4.1 Definitions Related to Childbearing Potential summary as needed.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Specify the definitions of participant of childbearing potential, and participant of nonchildbearing potential.</p>
        </div>
        <p>Enter or revise 5.4.2 Contraception Requirements summary as needed.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Specify the contraceptive methods required, and duration of use.</p>
        </div>
        <p>Enter data for Section 5.5 Lifestyle Restrictions.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>In the following subsections, describe any restrictions during the trial pertaining to lifestyle and/or diet, intake of caffeine, alcohol, or tobacco, or physical and other activities. If not applicable, include a statement that no restrictions are required.</p>
            <p>For Section 5.5.1 Meals and Dietary Restrictions: If applicable, describe any restrictions on diet (for example, food and drink restrictions, timing of meals relative to dosing, etc.).</p>
            <p>For Section 5.5.2 Caffeine, Alcohol, Tobacco, and Other Restrictions: If applicable, describe any restrictions on the intake of caffeine, alcohol, tobacco, or other restrictions.</p>
            <p>For Section 5.5.3 Physical Activity Restrictions: If applicable, describe any restrictions on activity (for example, in first-in-human trials, activity may be restricted by ensuring participants remain in bed for 4 to 6 hours after dosing).</p>
            <p>For Section 5.5.4 Other Activity Restrictions: If applicable, describe restrictions on any other activity (for example, blood or tissue donation, driving, heavy machinery use, or sun exposure).</p>
        </div>
        <p>Enter data for Section 5.6 Screen Failure and Rescreening.</p>
        <div style={{ marginLeft: "24px" }} >
            <p>Describe screen failure and indicate how screen failure will be handled in the trial, including conditions and criteria upon which rescreening is acceptable. If applicable, indicate the circumstances and time window under which a repeat procedure is allowed for screen failure relating to specific inclusion/exclusion criteria for the trial.</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step007TrialPopulationValidationCheck = ({ }) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [validationCheckState, setValidationCheckState] = useState({});

    useEffect(() => {
        if (m11ResearchStudyFoi) {
            validateStep(apiToken, 7, m11ResearchStudyFoi,
                setValidationCheckState)
        }
    }, [m11ResearchStudyFoi]);

    return <div>{validationCheckState?.success && <div>
        <h4>Step 7 (Complete Section 5 Trial Population) {validationCheckState.step07numberOfChecks} issues checked. {validationCheckState.step07numberPassed} passed. {validationCheckState.step07numberFailed} failed.</h4>
        <p>Section 5 heading is 'TRIAL POPULATION': {validationCheckState.resultCheckSection5Heading}</p>
        <p>Section 5 TRIAL POPULATION does not have text: {validationCheckState.resultCheckSection5Text}</p>
        <p>Section 5.1 heading is 'Description of Trial Population and Rationale': {validationCheckState.resultCheckSection51Heading}</p>
        <p>Section 5.1 Description of Trial Population and Rationale has content and includes 'Prospective approval of protocol deviations to recruitment and enrollment criteria, also known as protocol waivers or exemptions, is not permitted.': {validationCheckState.resultCheckSection51Content}</p>
        <p>Section 5.2 heading is 'Inclusion Criteria': {validationCheckState.resultCheckSection52Heading}</p>
        <p>Section 5.2 Inclusion Criteria has content and includes 'To be eligible to participate in this trial, an individual must meet all the following criteria:': {validationCheckState.resultCheckSection52Content}</p>
        <p>Section 5.3 heading is 'Exclusion Criteria': {validationCheckState.resultCheckSection53Heading}</p>
        <p>Section 5.3 Exclusion Criteria has content and includes 'An individual who meets any of the following criteria will be excluded from participation in this trial:': {validationCheckState.resultCheckSection53Content}</p>
        <p>Section 5.4 heading is 'Contraception': {validationCheckState.resultCheckSection54Heading}</p>
        <p>Section 5.4 Contraception does not have text: {validationCheckState.resultCheckSection54Text}</p>
        <p>Section 5.4.1 heading is 'Definitions Related to Childbearing Potential': {validationCheckState.resultCheckSection541Heading}</p>
        <p>Section 5.4.1 Definitions Related to Childbearing Potential has content: {validationCheckState.resultCheckSection541Content}</p>
        <p>Section 5.4.2 heading is 'Contraception Requirements': {validationCheckState.resultCheckSection542Heading}</p>
        <p>Section 5.4.2 Contraception Requirements has content: {validationCheckState.resultCheckSection542Content}</p>
        <p>Section 5.5 heading is 'Lifestyle Restrictions': {validationCheckState.resultCheckSection55Heading}</p>
        <p>Section 5.5 Lifestyle Restrictions has content or subheadings: {validationCheckState.resultCheckSection55Content}</p>
        <p>If present, Section 5.5.1 heading is 'Meals and Dietary Restrictions': {validationCheckState.resultCheckSection551Heading}</p>
        <p>If present, Section 5.5.1 Meals and Dietary Restrictions has content: {validationCheckState.resultCheckSection551Content}</p>
        <p>If present, Section 5.5.2 heading is 'Caffeine, Alcohol, Tobacco, and Other Restrictions': {validationCheckState.resultCheckSection552Heading}</p>
        <p>If present, Section 5.5.2 Caffeine, Alcohol, Tobacco, and Other Restrictions has content: {validationCheckState.resultCheckSection552Content}</p>
        <p>If present, Section 5.5.3 heading is 'Physical Activity Restrictions': {validationCheckState.resultCheckSection553Heading}</p>
        <p>If present, Section 5.5.3 Physical Activity Restrictions has content: {validationCheckState.resultCheckSection553Content}</p>
        <p>If present, Section 5.5.4 heading is 'Other Activity Restrictions': {validationCheckState.resultCheckSection554Heading}</p>
        <p>If present, Section 5.5.4 Other Activity Restrictions has content: {validationCheckState.resultCheckSection554Content}</p>
        <p>Section 5.6 heading is 'Screen Failure and Rescreening': {validationCheckState.resultCheckSection56Heading}</p>
        <p>Section 5.6 Screen Failure and Rescreening has content: {validationCheckState.resultCheckSection56Content}</p>
    </div>}  </div>
}

export default M11Step007TrialPopulation;
export { M11Step007TrialPopulationHelperText, M11Step007TrialPopulationValidationCheck };